import { Component, EventEmitter, Input, Output } from '@angular/core';

import { UserWeb } from 'app/users/user.model';

@Component({
  selector: 'cc-active-users-table-row',
  templateUrl: './active-users-table-row.component.html',
  styleUrls: ['./active-users-table-row.component.scss'],
})
export class ActiveUsersTableRowComponent {
  @Input() index: number;
  @Input() user: UserWeb;
  @Input() searchTerm = '';
  @Input() canRemoveUser = false;
  @Output() check: EventEmitter<UserWeb> = new EventEmitter();
  @Input() isChecked: boolean;
  @Input() showPermissionToggle: boolean;
  @Input() canUpdateUserPermission: boolean;
  @Input() permissionOptions: string[];
  @Output() onUpdatePermission = new EventEmitter();

  onCheck(user) {
    this.check.emit(user);
  }
}
